<template>
  <v-dialog v-model="dialog" persistent width="950px">
    <CrearDuodecima />
    <v-card>
      <v-card-title class="headline">
        <v-icon>event</v-icon> Duodécimas
        <v-spacer></v-spacer>
        <v-btn icon @click="close()">
          <v-icon>close</v-icon>
        </v-btn>
      </v-card-title>
      <v-form
        @submit.prevent="adicionarDetalle()"
        v-model="valid"
        ref="form"
        lazy-validation
      >
        <v-card-text class="pt-0">
          <v-container grid-list-md class="pt-0" style="min-width: 100%;">
            <v-layout row wrap>
              <v-flex shrink>
                <!-- Nueva papeleta con cargo a  vacacion-->
                <v-tooltip bottom>
                  <v-btn
                    color="primary"
                    slot="activator"
                    @click="crearDuodecima({}, true)"
                    ><v-icon>add</v-icon> Nueva duodécima
                  </v-btn>
                  <span>Crear duodécima</span>
                </v-tooltip>
              </v-flex>
            </v-layout>
            <v-data-table
              :items="listado_duodecimas"
              class="elevation-1"
              hide-actions
              :headers="headers"
              :loading="loading_tabla2"
              no-data-text="No se tiene registros"
              no-results-text="No se encontraron coincidencias"
            >
              <template v-slot:items="props">
                <td class="text-xs-center">
                  <v-icon color="rgb(38,60,217)">{{ "event" }}</v-icon> {{ props.item.tipo_duodecima }}
                </td>
                <td class="text-xs-center">
                  {{ props.item.estado }}
                </td>
                <v-btn
                v-if="props.item.id_estado == 84"
                  color="rgb(217,101,38)"
                  icon
                  title="Editar"
                  @click="crearDuodecima(props.item, false)"
                >
                  <v-icon>edit</v-icon>
                </v-btn>
                <v-btn
                  v-if="props.item.id_estado == 84"
                  color="rgb(217,38,38)"
                  icon
                  title="Eliminar duodécima"
                  @click="eliminarDuodecima(props.item)"
                >
                  <v-icon>delete</v-icon>
                </v-btn>
                <v-btn
                  v-if="props.item.id_estado == 84"
                  color="rgb(141,51,204)"
                  icon
                  title="Validar duodécima"
                  @click="validarDuodecima(props.item)"
                >
                  <v-icon>done</v-icon>
                </v-btn>
                <td class="text-xs-center"></td>
              </template>
            </v-data-table>
          </v-container>
        </v-card-text>
        <v-card-actions class="pr-4">
          <v-spacer></v-spacer>
          <v-btn @click.native="close()" color="primary">
            <v-icon>cancel</v-icon> ACEPTAR
          </v-btn>
        </v-card-actions>
      </v-form>
    </v-card>
  </v-dialog>
</template>

<script>
import validate from "@/common/mixins/validate";
import Layout from "@/common/layout/mixins/layout";
import { parse } from "json5";
import CrearDuodecima from "./CrearDuodecima.vue";

export default {
  mixins: [validate],
  props: ["item"],
  // Definición de componentes importados
  components: {
    CrearDuodecima
  },
  async mounted() {
    this.$bus.$on("openDialogCabeceraDuodecima", async dato => {
      this.dato = dato;
      await this.listadoDuodecimasPorPersona();
      this.dialog = true;
      this.$bus.$on("closeDialogCrearDuodecima", async () => {
        await this.listadoDuodecimasPorPersona();
      });
    });

    this.getRuta();
  },
  data() {
    return {
      form: {},
      total_dias: 0,
      id_permi: "",
      fecha_desde: "",
      fecha_hasta: "",
      radio_data: "",
      dialog: false,
      edit: true,
      dias_saldo_para_papeletas: 0,
      loading_tabla2: false,
      listado_duodecimas: [],
      permiso: {
        id_tipo_permiso: null,
        motivo: "",
        permi_fecha_hasta: "",
        permi_fecha_desde: ""
      },
      permisos: [],
      tipo_permisos: [],
      permiso_compensacion: [],
      aux: {},
      permiso_detalle: {},
      dias_programados_por_gestion: 0,
      valid: false,
      loading: false,

      headers: [
        {
          text: "Tipo de duodécimas",
          align: "center",
          sortable: false
        },
        {
          text: "Estado",
          align: "center",
          sortable: false
        },
        { text: this.$t("common.actions"), sortable: false, align: "center" }
      ],
      permiso_detalles: [],
      count_id: 0,
      // variables nueva funcionalidad
      dato: {},
      tiempo_vacaciones: 0,
      v_fecha_desde: [],
      v_fecha_hasta: [],
      v_hora_desde: [],
      v_hora_hasta: [],
      total_dias_solicitadas: 0,
      total_dias_no_programados: 0
    };
  },
  methods: {
    //crear duodecima:
    crearDuodecima(item, bandera_nuevo) {
      item.id_persona = this.dato.id_persona;
      item.bandera_nuevo = bandera_nuevo;
      this.$bus.$emit("openDialogCrearDuodecima", item);
    },
    async calculaDiferenciaDias() {
      try {
        let res;

        if (
          this.form.fecha_desde &&
          this.form.fecha_hasta &&
          (this.form.radio_data == 1 ||
            this.form.radio_data == 2 ||
            this.form.radio_data == 0)
        ) {
          res = await this.$service.graphql({
            query: `
							query{
							runQuery(consulta:"select vacaciones.fn_obtiene_dias_habiles_entre_fechas('${this.form.fecha_desde}','${this.form.fecha_hasta}')"){
								respuesta
							}
							}
						`
          });
          // this.total_dias = res.runQuery.respuesta[0].fn_obtiene_dias_habiles_entre_fechas;
          let res2;
          if (this.form.radio_data == 1 || this.form.radio_data == 2) {
            res2 =
              parseInt(
                res.runQuery.respuesta[0].fn_obtiene_dias_habiles_entre_fechas
              ) / 2;
          }
          if (this.form.radio_data == 0) {
            res2 =
              res.runQuery.respuesta[0].fn_obtiene_dias_habiles_entre_fechas;
          }

          this.total_dias = res2;
        }
      } catch (error) {
        console.log(error);
      }
    },
    // Obtiene el horario de una persona
    async obtenerHorarioPersona(id_persona, id_radio_data) {
      try {
        let respuesta = await this.$service.graphql({
          query: `
            query{
              runQuery(consulta:"select control.fn_rango_horario_por_persona_solo_horarios(${parseInt(
                id_persona
              )},${parseInt(id_radio_data)},'${this.form.fecha_desde}')"){
                respuesta
              }
            }
          `
        });
        if (
          respuesta.runQuery.respuesta[0]
            .fn_rango_horario_por_persona_solo_horarios != null
        ) {
          respuesta = respuesta.runQuery.respuesta[0].fn_rango_horario_por_persona_solo_horarios.split(
            "|"
          );
          if (respuesta[0] != "0") {
            return [respuesta[0], respuesta[1]];
          } else {
            return "No";
          }
        } else {
          this.$message.warning(
            "Sin horario asignado para la fecha del permiso"
          );
        }
      } catch (error) {
        console.log(error);
      }
    },
    //listado de gestiones -periodo por persona:
    async listadoDuodecimasPorPersona() {
      try {
        //
        this.loading_tabla2 = true;
        let respuesta = await this.$service.graphql({
          query: `
              query{
                runQuery(consulta:"select * from vacaciones.v_duodecimas_vacacion vdv where vdv.id_persona=${this.dato.id_persona}"){
                respuesta
                }
              }
            `
        });
        respuesta = respuesta.runQuery.respuesta;
        this.listado_duodecimas = respuesta;
        this.loading_tabla2 = false;
     
      } catch (error) {
        console.log(error);
      }
    },
    //validar duodecima:
    async validarDuodecima(dato) {
      try {
        this.$confirm(
          "¿Esta seguro(a) de aprobar la duodécima?. Esta acción es irreversible",
          async () => {
            let user = this.$storage.get("user");
            let respuesta = await this.$service.graphql({
              query: `
              query{
                runQuery(consulta:"select vacaciones.fn_aprueba_duodecimas(${dato.id_duodecima_vacacion},${user.id})"){
                respuesta
                }
              }
            `
            });
            respuesta = respuesta.runQuery.respuesta[0].fn_aprueba_duodecimas
            let rpta=respuesta.split("|");
          if (rpta[0] == "1") {
            this.$message.info("La duodécima fue aprobada exitosamente")
          } else {
            this.$message.error(rpta[1])
          };
            await this.listadoDuodecimasPorPersona();
          }
        );
      } catch (error) {
        console.log(error);
      }
    },
    //elimina duodecima:
    async eliminarDuodecima(dato) {
      try {
        this.$confirm(
          "¿Esta seguro(a) de eliminar la duodécima?. Esta acción es irreversible",
          async () => {
            let user = this.$storage.get("user");
            let respuesta = await this.$service.graphql({
              query: `
              query{
                runQuery(consulta:"select vacaciones.fn_eliminar_duodecimas(${dato.id_duodecima_vacacion},${user.id})"){
                respuesta
                }
              }
            `
            });
            respuesta = respuesta.runQuery.respuesta[0].fn_eliminar_duodecimas
            let rpta=respuesta.split("|");
          if (rpta[0] == "1") {
            this.$message.info("La duodécima fue eliminada exitosamente")
          } else {
            this.$message.error(rpta[1])
          };
            await this.listadoDuodecimasPorPersona();
          }
        );
      } catch (error) {
        console.log(error);
      }
    },
    async verificaCreacionPermiso(
      fecha_desde,
      fecha_hasta,
      radio_data,
      hora_desde,
      hora_hasta,
      list_permiso_detalles
    ) {
      try {
        let respuesta = "";
        let rpta = "1";
        let vector_fecha_desde;
        let vector_fecha_hasta;
        let vector_hora_desde;
        let vector_hora_hasta;
        let bandera_vector;
        vector_fecha_desde = "{" + this.v_fecha_desde.join(",") + "}";
        vector_fecha_hasta = "{" + this.v_fecha_hasta.join(",") + "}";
        vector_hora_desde = "{" + this.v_hora_desde.join(",") + "}";
        vector_hora_hasta = "{" + this.v_hora_hasta.join(",") + "}";
        if (list_permiso_detalles.length < 1) {
          bandera_vector = 0;
        } else {
          bandera_vector = 1;
        }
        respuesta = await this.$service.graphql({
          query: `
                query{
                  runQuery(consulta:"select control.fn_valida_fechas_vacacion(${this.dato.id_persona},'${fecha_desde}','${fecha_hasta}','${hora_desde}','${hora_hasta}','${vector_fecha_desde}','${vector_fecha_hasta}','${vector_hora_desde}','${vector_hora_hasta}',${bandera_vector},null)"){
                  respuesta
                  }
                }
              `
        });
        respuesta = respuesta.runQuery.respuesta[0].fn_valida_fechas_vacacion;
        rpta = respuesta.split("|");
        if (rpta[0] == "3") {
          return rpta[1];
        } else if (rpta[0] == "0") {
          return "Registro exitoso|" + rpta[1];
        } else if (rpta[0] == "1") {
          return (
            "<br><strong>Usted tiene los siguientes permisos en las fechas u horarios solicitados:</strong><br>" +
            rpta[1].replace(/#/g, "<br>")
          );
        } else {
          let resp = rpta[1].split(",");
          return "Usted registro un detalle en fechas:" + resp[0] + " al ";
        }
      } catch (error) {
        console.log(error);
      }
    },
    validarFechasFinales() {
      let validacion_fechas;
      //validando fechas:
      let bandera_fechas = true;

      if (this.form.fecha_desde && this.form.fecha_hasta) {
        if (this.form.fecha_desde.length > 10) {
          this.$message.info("Año desde no valido");
          bandera_fechas = false;
          return bandera_fechas;
        }
        if (this.form.fecha_hasta.length > 10) {
          this.$message.info("Año desde no valido");
          bandera_fechas = false;
          return bandera_fechas;
        }
        let año1 = parseInt(this.form.fecha_desde.substring(0, 4));
        let año2 = parseInt(this.form.fecha_hasta.substring(0, 4));

        if (año1 > 2022) {
          if (año1 > 2999) {
            this.$message.info("Año desde no valido");
            bandera_fechas = false;
            return bandera_fechas;
          }
        }
        if (año2 > 2022) {
          if (año2 > 2999) {
            this.$message.info("Año desde no valido");
            bandera_fechas = false;
            return bandera_fechas;
          }
        }
        if (año1 < 2023) {
          this.$message.info("Año desde no valido");
          bandera_fechas = false;
          return bandera_fechas;
        }
        if (año2 < 2023) {
          this.$message.info("Año hasta no valido");
          bandera_fechas = false;
          return bandera_fechas;
        }
      }

      return bandera_fechas;
    },
    async adicionarDetalle() {
      if (this.$refs.form.validate()) {
        try {
          if (this.validarFechasFinales() == false) {
            return;
          }

          let horario = await this.obtenerHorarioPersona(
            this.dato.id_persona,
            this.form.radio_data
          );
          if (horario != "No") {
            let verifica_creacion_vacacion = await this.verificaCreacionPermiso(
              this.form.fecha_desde,
              this.form.fecha_hasta,
              this.form.radio_data,
              horario[0],
              horario[1],
              this.permiso_detalles
            );
            let verifica_creacion_vacacion_2 = verifica_creacion_vacacion.split(
              "|"
            );
            if (verifica_creacion_vacacion_2[0] == "Registro exitoso") {
              //sumar los dias y verificar que no se excedan los dias de su vacacion:
              this.total_dias_solicitadas += parseFloat(
                verifica_creacion_vacacion_2[1]
              );
              if (!this.total_dias_solicitadas) {
                this.total_dias_solicitadas = 0;
              }

              if (
                this.total_dias_solicitadas <= this.dato.saldo_no_programadas
              ) {
                //almacenar los datos ya verificados
                const temp = {
                  fecha_desde: this.form.fecha_desde,
                  fecha_hasta: this.form.fecha_hasta,
                  tipo: this.form.radio_data,
                  hora_desde: horario[0],
                  hora_hasta: horario[1],
                  id: this.count_id++,
                  total_dias: verifica_creacion_vacacion_2[1]
                };
                this.permiso_detalles.push(temp);
                this.v_fecha_desde.push(this.form.fecha_desde);
                this.v_fecha_hasta.push(this.form.fecha_hasta);
                this.v_hora_desde.push(horario[0]);
                this.v_hora_hasta.push(horario[1]);
                this.form = {};
                this.$message.success("Detalle Agregado.");
              } else {
                this.total_dias_solicitadas -= parseFloat(
                  verifica_creacion_vacacion_2[1]
                );
                this.$message.info(
                  "Excede el total de dias de su saldo de vacacion"
                );
              }
            } else {
              this.$message.info(verifica_creacion_vacacion);
            }
          } else {
            this.$message.info("Usted no tiene un horario laboral asignado");
          }
        } catch (error) {
          console.log(error);
        }
      }
    },
    eliminarDetalle(id) {
      let tempList = this.permiso_detalles;
      for (let i = 0; i <= tempList.length; i++) {
        if (tempList[i].id === id) {
          this.total_dias_solicitadas -= parseFloat(tempList[i].total_dias);
          tempList.splice(i, 1);
          this.v_fecha_desde.splice(i, 1);
          this.v_fecha_hasta.splice(i, 1);
          this.v_hora_desde.splice(i, 1);
          this.v_hora_hasta.splice(i, 1);
          break;
        }
      }
      this.permiso_detalles = tempList;
      this.valid = true;
      this.$message.success("Detalle Eliminado");
    },
    close() {
      this.form = {};
      this.total_dias_solicitadas = 0;
      this.dialog = false;
      this.permiso = {
        id_tipo_permiso: null,
        motivo: ""
      };
      this.permiso_detalles = [];
      this.count_id = 0;
      this.edit = true;
      this.$bus.$emit("closeDialogCrearDuodecima");
    },

    getRuta() {
      let p = this.$route.path;
      const a = p.split("/");
      return a[3];
    },
    async save() {
      let respuesta;

      let user = this.$storage.get("user");
      let id = user.id;
      let bandera_exito = false;
      let error_texto = "-1";
      try {
        let user = this.$storage.get("user");
        for (let i = 0; i < this.permiso_detalles.length; i++) {
          const elemento = this.permiso_detalles[i];
          respuesta = await this.$service.graphql({
            query: `
              query{
                runQuery(consulta:"select control.fn_registra_cta_vacacion_cabecera(${this.dato.id_persona},${user.id})"){
                respuesta
                }
              }
            `
          });
          respuesta =
            respuesta.runQuery.respuesta[0].fn_registra_cta_vacacion_cabecera;
          let resps = respuesta.split("|");
          let correcto = resps[0];
          if (correcto == "1") {
            let id_permiso = parseInt(resps[1]);
            respuesta1 = await this.$service.graphql({
              query: `
              query{
                runQuery(consulta:"select control.fn_registra_cta_vacacion_detalle(${id_permiso},${
                user.id
              },'${elemento.fecha_desde}','${elemento.fecha_hasta}','${
                elemento.hora_desde
              }','${elemento.hora_hasta}',${parseInt(this.dato.rol)})"){
                respuesta
                }
              }
            `
            });
            let respuesta1 =
              respuesta1.runQuery.respuesta[0].fn_registra_cta_vacacion_detalle;
            let res = respuesta1.split("|");
            let correcto = res[0];
            if (correcto == "1") {
              bandera_exito = true;
            } else {
              bandera_exito = false;
              error_texto = res[1];
            }
          } else {
            this.$confirm(resps[1], () => {});
          }
        }

        if (bandera_exito == true) {
          this.close();
        } else {
          this.$message.error(error_texto);
        }
      } catch (error) {
        console.log(error);
      }
    }
  }
};
</script>

<style>
.titulo {
  font-size: 1.07em;
  color: rgb(24, 106, 121);
  font-weight: bold;
}
.texto {
  font-size: 1.07em;
  color: rgb(24, 106, 121);
}
</style>



// WEBPACK FOOTER //
// src/components/admin/vacacion_rrhh/dialogs/CabeceraDuodecima.vue